/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Box, Typography, CircularProgress, useTheme } from '@mui/material';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { useDispatch } from 'react-redux';
import { NoContextTabView } from '@/components/layouts/TabView';
import { setTemplate } from '@/features/templates/templatesSlice';
import { getTemplateTabs } from '@/app/tabs';
import { useLocation } from 'react-router-dom';
import { TemplatesIcon } from '@/components/icons/TemplatesIcon';

export const EmailView = () => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const location = useLocation();

	const { getFeatureFlags, isLoading } = useFeatureFlagContext();
	const saveEmailTemplates = Boolean(getFeatureFlags('saveEmailTemplates')?.active);
	const viewAIHtmlTemplates = Boolean(getFeatureFlags('viewAIHtmlTemplates')?.active);

	const ComingSoonView = () => (
		<Box px={'1em'}>
			{isLoading ? <CircularProgress /> : <Typography>{'Coming soon.'}</Typography>}
		</Box>
	);

	const isAiTemplatesPath = location.pathname.endsWith('/aiTemplates');

	const tabs = useMemo(() => {
		return getTemplateTabs().reduce((acc, tab) => {
			if (tab.value === 'aiTemplates' && viewAIHtmlTemplates) acc.push(tab);
			if (tab.value === '')
				acc.push(
					saveEmailTemplates
						? tab
						: {
								label: 'Templates',
								value: '',
								ContentComponent: ComingSoonView,
								showComponent: true,
							},
				);
			if (tab.value === 'create' && saveEmailTemplates) acc.push(tab);
			return acc;
		}, []);
	}, [saveEmailTemplates, viewAIHtmlTemplates]);

	if (isLoading && isAiTemplatesPath) {
		return (
			<Box px='1em' mt='1em'>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<NoContextTabView
			tabs={tabs}
			title='Emails'
			onTabChange={(tab) => {
				if (tab === tabs[0].value) {
					dispatch(setTemplate(null));
				}
			}}
			icon={
				<TemplatesIcon
					{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
				/>
			}
		/>
	);
};
